import api from './http';

// Payment Links Stripe
export const createPaymentLink = (data) => api.post('/payment-links', data);
export const listPaymentLinks = (params = {}) => api.get(`/payment-links${new URLSearchParams(params).toString() ? `?${new URLSearchParams(params).toString()}` : ''}`);
export const getPaymentLinkStatus = (id) => api.get(`/payment-links/${id}/status`);
export const sendPaymentLink = (id, payload) => api.post(`/payment-links/${id}/send`, payload);
export const getPaymentLinkQr = (id, size = 8) => api.get(`/payment-links/${id}/qr?size=${size}`, { responseType: 'blob' });
export const getDossierPaymentLinks = (dossierId) => api.get(`/dossiers/${dossierId}/payment-links`);
export const getDossierBankTransfers = (dossierId) => api.get(`/dossiers/${dossierId}/bank-transfers`);

// Payments
export const getPayments = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/payments${queryString ? `?${queryString}` : ''}`);
};
export const createPayment = (data) => api.post('/payments', data);
export const updatePayment = (id, data) => api.patch(`/payments/${id}`, data);
export const receivePayment = (id, montant, reference, date_reglement, mode_reglement) => {
  const params = new URLSearchParams();
  if (montant != null) params.append('montant', montant);
  if (reference) params.append('reference', reference);
  if (date_reglement) params.append('date_reglement', date_reglement);
  if (mode_reglement) params.append('mode_reglement', mode_reglement);
  return api.post(`/payments/${id}/receive?${params.toString()}`);
};

// Payment Gateways
export const getPaymentGatewaysConfig = () => api.get('/payment-gateways/config');
export const updatePaymentGatewaysConfig = (data) => api.patch('/payment-gateways/config', data);
export const stripeCheckout = (data) => api.post('/payment-gateways/stripe/checkout', data);
export const stripeCheckStatus = (sessionId) => api.get(`/payment-gateways/stripe/status/${sessionId}`);
export const paypalCheckout = (data) => api.post('/payment-gateways/paypal/checkout', data);
export const paypalExecute = (data) => api.post('/payment-gateways/paypal/execute', data);
export const paypalTestConnection = () => api.post('/payment-gateways/paypal/test');
export const getPaymentTransactions = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.payment_id) qs.append('payment_id', params.payment_id);
  if (params.gateway) qs.append('gateway', params.gateway);
  if (params.limit) qs.append('limit', params.limit);
  return api.get(`/payment-transactions?${qs.toString()}`);
};

// Finance
export const getFinanceDashboard = (year) => api.get(`/finance/dashboard${year ? `?year=${year}` : ''}`);
export const getBankDetails = () => api.get('/finance/bank-details');
export const updateBankDetails = (data) => api.patch('/finance/bank-details', data);
export const sendBankTransferInfo = (data) => api.post('/finance/send-bank-transfer-info', data);
export const createStripePaymentLink = (data) => api.post('/finance/stripe-payment-link', data);

// Company-level bank details (shared coordinates + RIB PDF)
export const getCompanyBankDetails = () => api.get('/company/bank-details');
export const updateCompanyBankDetails = (data) => api.patch('/company/bank-details', data);
export const uploadCompanyRib = (formData) => api.post('/company/bank-details/rib-upload', formData, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const downloadCompanyRib = () => api.get('/company/bank-details/rib', { responseType: 'blob' });
export const sendBankTransferDetails = (payload) => api.post('/payments/bank-transfer/send', payload);

// Invoices (generated after Stripe payment)
export const listInvoices = (params = {}) => api.get(`/invoices${new URLSearchParams(params).toString() ? `?${new URLSearchParams(params).toString()}` : ''}`);
export const getInvoice = (id) => api.get(`/invoices/${id}`);
export const downloadInvoice = (id) => api.get(`/invoices/${id}/download`, { responseType: 'blob' });
export const viewInvoice = (id) => api.get(`/invoices/${id}/view`, { responseType: 'blob' });
export const regenerateInvoice = (paymentLinkId) => api.post(`/invoices/regenerate/${paymentLinkId}`);
export const exportInvoices = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return api.get(`/invoices/export${qs ? `?${qs}` : ''}`, { responseType: 'blob' });
};

// TVA config
export const getTvaRates = () => api.get('/company/tva-rates');
export const updateTvaRates = (data) => api.patch('/company/tva-rates', data);

// Quotes (Devis) - workflow devis -> signature -> paiement
export const createQuote = (data) => api.post('/quotes', data);
export const listQuotes = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return api.get(`/quotes${qs ? `?${qs}` : ''}`);
};
export const getQuote = (id) => api.get(`/quotes/${id}`);
export const downloadQuote = (id) => api.get(`/quotes/${id}/download`, { responseType: 'blob' });
export const viewQuote = (id) => api.get(`/quotes/${id}/view`, { responseType: 'blob' });
export const sendQuote = (id, data = {}) => api.post(`/quotes/${id}/send`, data);
export const extendQuote = (id, validityDays = 30) => api.post(`/quotes/${id}/extend`, { validity_days: validityDays });
export const deleteQuote = (id) => api.delete(`/quotes/${id}`);
export const getQuotesConversionStats = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return api.get(`/dashboard/quotes-conversion${qs ? `?${qs}` : ''}`);
};

// SEPA
export const getSepaMandate = () => api.get('/sepa/mandates');
export const createSepaMandate = (data) => api.post('/sepa/mandates', data);
export const updateSepaMandate = (id, data) => api.patch(`/sepa/mandates/${id}`, data);
export const initiateSepaDebit = (data) => api.post('/sepa/debit', data);
export const getSepaTransactions = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.mandate_id) qs.append('mandate_id', params.mandate_id);
  if (params.payment_id) qs.append('payment_id', params.payment_id);
  return api.get(`/sepa/transactions?${qs.toString()}`);
};

// Payment schedules (echeanciers)
export const createPaymentSchedule = (data) => api.post('/finance/schedules', data);
export const getPaymentSchedules = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.organization_id) qs.append('organization_id', params.organization_id);
  return api.get(`/finance/schedules?${qs.toString()}`);
};
export const getPaymentSchedule = (id) => api.get(`/finance/schedules/${id}`);

// Reminders (relances)
export const getReminderSettings = () => api.get('/finance/reminder-settings');
export const updateReminderSettings = (data) => api.patch('/finance/reminder-settings', data);
export const getRemindersHistory = (params = {}) => {
  const qs = new URLSearchParams();
  if (params.limit) qs.append('limit', params.limit);
  if (params.skip) qs.append('skip', params.skip);
  if (params.schedule_id) qs.append('schedule_id', params.schedule_id);
  return api.get(`/finance/reminders/history?${qs.toString()}`);
};
export const triggerReminderScan = () => api.post('/finance/reminders/trigger');
